import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

type ActionItem = {
    id: string;
    title: string;
    icon: string;
    route: string;
    color: string;
    description?: string;
    badge?: string;
    badgeType?: 'info' | 'success' | 'warning' | 'danger';
};

type QuickActionsCardProps = {
    actions: ActionItem[];
};

const QuickActionsCard: React.FC<QuickActionsCardProps> = ({ actions }) => {
    const navigate = useNavigate();
    const [activeTab, setActiveTab] = useState<string>('actions');

    const handleActionClick = (route: string) => {
        navigate(route);
    };

    return (
        <div className="quick-actions-card dashboard-card-wrapper coming-soon-card">
            <h2 className="card-title">Quick Actions</h2>

            <div className="tabs-header">
                <button className={`tab-btn ${activeTab === 'actions' ? 'active' : ''}`} onClick={() => setActiveTab('actions')}>
                    Actions
                </button>
                <button className={`tab-btn ${activeTab === 'approvals' ? 'active' : ''}`} onClick={() => setActiveTab('approvals')}>
                    Approvals
                    {activeTab !== 'approvals' && <span className="badge badge-danger">4</span>}
                </button>
            </div>

            <div className="action-items-list">
                {actions.map((action) => (
                    <div key={action.id} className="action-list-item" onClick={() => handleActionClick(action.route)}>
                        <div className="action-icon" style={{ backgroundColor: action.color }}>
                            <i className={action.icon}></i>
                        </div>
                        <div className="action-content">
                            <div className="action-title">{action.title}</div>
                            {action.description && <div className="action-description">{action.description}</div>}
                        </div>
                        {action.badge && <span className={`badge badge-${action.badgeType || 'info'}`}>{action.badge}</span>}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default QuickActionsCard;
